import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Options, Questions } from '../../../data/wizard';

import styles from './QuestionOption.module.css';

type Props = {
  id: Options;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  questionId: Questions;
  translationKey: string;
};

const QuestionOption = ({
  id,
  onChange,
  questionId,
  translationKey,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.option}>
      <label className={styles.label} htmlFor={id}>
        <div className={styles.labelText}>
          <p className={styles.name}>{t(`${translationKey}.Name`)}</p>
          <p className={styles.description}>
            {t(`${translationKey}.Description`)}
          </p>
        </div>
        <input
          type="checkbox"
          id={id}
          name={questionId}
          value={id}
          className={styles.checkbox}
          onChange={onChange}
        />
        <span className={styles.checkmark} />
      </label>
    </div>
  );
};

export default QuestionOption;
